// IMPORTS
import Db from '@/dixie.js'
import Swal from 'sweetalert2'
import Router from '@/router'

const evntUserIsLogged = "userIsLogged";

const swalWithBootstrapButtons = Swal.mixin({
	customClass: {
		confirmButton: 'btn btn-xs btn-danger',
		cancelButton: 'btn btn-xs'
	},
	buttonsStyling: false
})

// DEFINITIONS
const state = {
	user: null,
	permisos: []
}

const getters = {
	isLogged: (state) => { return (!!state.user) },
	authGetPermisos: (state) => { 
		return state.permisos
	},
	authGetUser: (state) => { 
		return state.user
	},
	authToken: (state) => { 
		return (!!state.user && !!state.user.token)? state.user.token : null 
	}
}

const mutations = {
	authUpdate: (state, payload ) => {
		state.user = payload.user
		if(payload.permisos)
			state.permisos = payload.permisos
		Db.configs.where('key').equalsIgnoreCase('user').delete().then(()=>{
			Db.configs.add({
				key: 'user',
				value: JSON.stringify(payload)
			})
		})
	},
	accountClean: (state) => {
		state.processing = false
		Db.configs.where('key').equalsIgnoreCase('token').delete()
		Db.configs.where('key').equalsIgnoreCase('user').delete()
		state.token = null
		state.user = null
	}
}

const actions = {
	recoverFromDixie: async ({commit, getters}) => {
		try {
			let user = await Db.configs.where('key').equalsIgnoreCase('user').first()
			commit('authUpdate', JSON.parse(user.value))
			return getters.isLogged;
		} catch(e){
			console.error('No hay registro en INDEXED', e)
		}
		return false;
	},
	authTryLogout: ( {commit} ) => {
		swalWithBootstrapButtons.fire({
			title: '¿Seguro que deseas cerrar sesión y salir?',
			type: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Finalizar sesión',
			cancelButtonText: 'Cancelar',
			reverseButtons: true
		}).then((result) => {
			if (result.value) {
				commit('accountClean')
				Router.push({name: 'Home'})
				swalWithBootstrapButtons.fire(
					'¡Hasta pronto!',
					'Tu sesión ha sido terminada.',
					'success'
				)
			}
		})
	}
}

// EXPORTS
export default {
	state,
	getters,
	mutations,
	actions,
	evntUserIsLogged
};
